module.exports = __webpack_public_path__ + "img/BRCA3_DC.6570d15e.png";